import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import IconButton from '@material-ui/core/IconButton';
import AlertDrawer from '../AlertDrawer/AlertDrawer';
import AreaChart from '../AreaChart/AreaChart';
import { formatDateTime } from '../../utils/format-time';
import { updateAlert } from 'src/utils/api';
import { createActiveAlerts } from 'src/utils/alerts';
import * as utils from './utils';
import { styles } from '../../styles/card-styles';
import { Tooltip } from '@material-ui/core';
import ChartCardContentContainer from './ChartCardContentContainer';
import '../../styles/flash.css'

function ChartCard(props) {
  const { classes } = props;
  const getFlashingClass = (activeAlerts) => {
    setTimeout(function() {
      setFlashingClass(alertBorderClass)
    }, 20000);
    
    return  activeAlerts.length !== 0 ? "flash" : alertBorderClass;
  }
  const [expanded, setExpanded] = useState(false);
  const [activeAlerts, setActiveAlerts] = useState(createActiveAlerts(props.alerts));
  const [alertCutoff, setAlertCutoff] = useState(props.alertCutoff)
  const alertBorderClass = activeAlerts.length !== 0 ? classes.alert : null;
  const [flashingClass, setFlashingClass] = useState(getFlashingClass(createActiveAlerts(props.alerts)))
  
  useEffect(() => {
    handleAlerts(props.alerts);
    setFlashingClass(getFlashingClass(createActiveAlerts(props.alerts)));
  }, [handleAlerts, props.alerts]);

  const handleAlerts = (alerts) => {
    const newActiveAlerts = createActiveAlerts(alerts);
    setActiveAlerts(newActiveAlerts);
  }
  const data = utils.buildChartData(props.data, props.rangeSetting, props.chartType);
  const alert = activeAlerts.length !== 0 ? true : false;
  const unit = props.type === "transfer" ? "mins" : "secs";
  return (
      <div className={flashingClass}>
      <Card classes={{root: classes.card}}>
        <CardHeader
          classes={{root: classes.header}}
          action={
            <div className={classes.actions}>
              <AlertDrawer 
                alert={alert} 
                alerts={props.alerts}
                activeAlerts={activeAlerts}
                title={props.title} 
                handleAlerts={handleAlerts}
                rangeSetting={props.rangeSetting}
                fetchMonitors={props.fetchMonitors}
                updateAlertInState={props.updateAlertInState}
                monitorId={props.monitorId}
                type={props.type}
                unit={unit}
                alertCutoff={props.alertCutoff}
                handleAlertCutoffChange={props.handleAlertCutoffChange}
                handleDeleteAlertsFromState = {props.handleDeleteAlertsFromState}
              />

              {!props.detailsMonitorId 
                ?<Tooltip title="Expand chart for more details" placement="right">
                  <IconButton onClick={e => {props.handleSetMonitorId(e, props.monitorId)}}>
                    <FullscreenIcon />
                  </IconButton>
                </Tooltip>
                : null}
            </div>
          }
          title={props.title}
          titleTypographyProps={
            {
              component:"h2",
              variant:"h5",
              align: "left"
            }
          }
        />
        <ChartCardContentContainer {...props} data={data.data} 
            unit={unit} 
            alerts={props.alerts} 
            rangeSetting={props.rangeSetting} 
            chartProps={props}/>
      </Card>    
      </div>    
  );
}


ChartCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChartCard);



// WEBPACK FOOTER //
// ./src/components/ChartCard/ChartCard.js